import { appConfig } from '../../utils/appConfig';
import DropdownSearch from './_DropdownSearch';
import Button, { ButtonVariant } from '../Button';
import { Anchor } from '../Anchor';
import { classNames } from '../../utils/classNames';
import { navigationClicked } from '../../services/analytics';
import { LinkProps } from '../../types';
import { LinkWithIconProps } from './_LinkGroup';

interface Props {
  rightContent: {
    title: string;
    links: Array<LinkProps>;
    socialLinks?: {
      title?: string;
      links?: Array<LinkWithIconProps>;
    };
    search: {
      searchBy: string;
      searchPlaceholder: string;
    };
  };
  searchLink?: LinkProps;
  SocialLinks?: React.ComponentType<{ socialLinks: any }>;
  primaryHeader?: string;
  secondaryHeader?: string;
}

const RightContent = ({
  rightContent,
  SocialLinks,
  searchLink,
  secondaryHeader,
  primaryHeader,
}: Props) => {
  const rightLinks = rightContent?.links?.filter(
    (item) => !!item?.displayName && item.asButton !== true,
  );
  const buttonItems = rightContent?.links?.filter((link) => link.asButton === true);
  const hasButton = !!buttonItems?.length;

  return (
    <div className="px-4 sm:px-0">
      {rightContent?.search && (
        <div>
          <DropdownSearch {...rightContent.search} link={searchLink?.link} />
        </div>
      )}
      <div>
        {(!!rightLinks?.length || !!buttonItems?.length) && (
          <ul className={classNames('px-0 list-none', appConfig.isMeater && 'flex flex-col gap-3')}>
            {rightLinks.map(({ link, displayName, isExternal, externalLink, anchorTag }, index) => (
              <li key={index}>
                {appConfig.isMeater ? (
                  <Anchor
                    isExternal={isExternal}
                    externalLink={externalLink}
                    link={link}
                    displayName={displayName}
                    className="tra-text-web-body-l text-neutral-600 pb-4 hover:text-brand-300 hover:underline"
                  />
                ) : (
                  <Button
                    key={displayName}
                    isExternal={isExternal}
                    externalLink={externalLink}
                    variant={ButtonVariant.knife}
                    link={link}
                    anchorTag={anchorTag}
                    as={Anchor}
                    className={classNames(
                      'text-neutral-700 !flex !justify-between !w-full rounded-none !tra-text-web-sub-3 !pb-4 !pt-4 first:pt-0',
                      (!rightContent?.socialLinks || hasButton) && 'last:border-b-0',
                      index === 0 && !rightContent?.search && '!pt-0',
                    )}
                    onClick={() =>
                      navigationClicked({
                        nav_type: 'Top Navigation',
                        clicked_text: displayName ?? '',
                        primary_header: primaryHeader ?? '',
                        secondary_header: secondaryHeader ?? '',
                        tertiary_header: displayName ?? '',
                      })
                    }
                  >
                    {displayName}
                  </Button>
                )}
                {index !== rightLinks.length - 1 && !appConfig.isMeater && (
                  <hr className="border-warm-300 border-b" />
                )}
              </li>
            ))}
            {buttonItems?.map(
              ({ link, displayName, isExternal, externalLink, anchorTag }, index) => (
                <li key={index + (rightLinks?.length ?? 0)}>
                  <Button
                    key={displayName}
                    isExternal={isExternal}
                    externalLink={externalLink}
                    variant={ButtonVariant.secondary}
                    link={link}
                    anchorTag={anchorTag}
                    as={Anchor}
                    full
                    size={appConfig.isTraeger ? 'small' : 'medium'}
                    className={classNames('text-neutral-700 text-center !w-fit')}
                    onClick={() =>
                      navigationClicked({
                        nav_type: 'Top Navigation',
                        clicked_text: displayName ?? '',
                        primary_header: primaryHeader ?? '',
                        secondary_header: secondaryHeader ?? '',
                        tertiary_header: displayName ?? '',
                      })
                    }
                  >
                    {displayName}
                  </Button>
                </li>
              ),
            )}
          </ul>
        )}
        {rightContent?.socialLinks && SocialLinks && (
          <SocialLinks socialLinks={rightContent.socialLinks} />
        )}
      </div>
    </div>
  );
};
export default RightContent;
